module.exports = __webpack_public_path__ + "img/T360_survey.d61311a1.png";